<template>
    <section>
        <div :class="{ 'language-selection__wrapper': !single }">
            <h4 class="language-selection__title" v-if="!single">
                {{ $t('SELECT_YOUR_PATIENT_ACCOUNT_LANGUAGE') }}
            </h4>
            <div class="content__wrapper flex-row">
                <div class="row">
                    <div class="el-col-xs-12 el-col-sm-12 mr-3">
                        <el-select v-model="lngSelected" :placeholder="$t('SELECT')" class="xs6 flex-select mb-3">
                            <el-option
                                v-for="lang in interfaceLanguages"
                                :key="lang"
                                :label="$t('NAME_NATIVE', lang)"
                                :value="lang"
                            />
                        </el-select>
                    </div>
                    <div class="el-col-xs-12 el-col-sm-6">
                        <button @click="selectLanguage" class="w160 mr-3 app-btn app-btn--big app-btn-primary">
                            {{ $t('APPLY') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { init } from './../../../main';
import { interfaceLanguages } from './../../../countries';

export default {
    name: 'language-selection',
    props: {
        single: Boolean,
    },
    data() {
        return {
            lngSelected: this.$store.state.interfaceLanguage,
            interfaceLanguages,
        };
    },
    methods: {
        selectLanguage() {
            const languages = {
                documentLanguage: this.lngSelected,
                interfaceLanguage: this.lngSelected,
            };
            if (this.$store.state.interfaceLanguage !== this.lngSelected) {
                this.$http.patch('/user/api/settings/currentLanguages', languages).then(() => init(this.lngSelected));
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.language-selection {
    &__wrapper {
        background-color: #fff;
        border: 1px solid #f1eeea;
        padding: 50px 30px;
    }

    &__title {
        color: #1d1d1d;
        font-size: 21px;
        font-weight: 700;
        margin-bottom: 30px;
        margin-top: 0;
        text-align: left;
    }
}
</style>



// WEBPACK FOOTER //
// language-selection.vue?ac770b94